import React, { useMemo} from 'react';
import Select from 'react-select';
import FormHelperText from '@material-ui/core/FormHelperText';
import { banks } from 'utils/banks';

const SelectStates = React.memo(
  ({
    isMulti = false,
    onSelect,
    placeholder = 'انتخاب بانک',
    bank = null,
    isDisabled = false,
    width = '100%',
    height = 56,
    isClearable = true,
    hasLabel = false,
    error = false,
    helperText = '',
    ...rest
  }) => {

    const handleSelectBank = (bank) => {
      onSelect(bank);
    };

    const customStyles = {
      menu: (provided, state) => ({
        ...provided,
        zIndex: 10,
      }),
      control: (provided, state) => ({
        ...provided,
        height,
        width,
      }),
    };

    const selectedBank = useMemo(()=>{},[])

    return (
      <>
        <div style={{ position: 'relative' }}>
          <Select
            options={banks}
            isMulti={isMulti}
            isSearchable={true}
            placeholder={placeholder}
            value={bank}
            onChange={(option) => handleSelectBank(option)}
            noOptionsMessage={() => 'بانکی یافت نشد!'}
            isDisabled={isDisabled}
            isClearable={isClearable}
            styles={customStyles}
            {...rest}
          />
          {bank && hasLabel && (
            <label
              style={{
                position: 'absolute',
                top: -8,
                right: 10,
                fontSize: 12,
                color: 'gray',
                background: '#fff',
                padding: '0 5px',
              }}
            >
              {placeholder}
            </label>
          )}
          <FormHelperText error={error}>{helperText}</FormHelperText>
        </div>
      </>
    );
  }
);

export default React.memo(SelectStates);
